"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.nevadaCompareSystems = exports.nevadaCreateRevision = void 0;
const queries_1 = require("../nevada-shared/queries");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.nevadaCreateRevision = (0, graphql_tag_1.default) `
  mutation NevadaTestCreateRevision(
    $systemFileId: ID!
    $comment: String!
    $revisionNo: Float!
  ) {
    nevadaCreateNewSystemRevision(
      systemFileId: $systemFileId
      comment: $comment
      revisionNo: $revisionNo
    ) {
      hasError
      errorMessage
      systemFile {
        id
        systemTypeId
        name
        systems {
          id
          revisionNo
        }
      }
    }
  }
`;
exports.nevadaCompareSystems = (0, graphql_tag_1.default) `
  query NevadaCompareSystems($input: NevadaCompareSystemRevisionsInputType!) {
    user {
      nevadaCompareSystemRevisions(input: $input) {
        ...CompareResults
      }
    }
  }

  ${queries_1.compareResultFragment}
`;
//# sourceMappingURL=queries.js.map